let splashes = document.querySelectorAll(".splash")

window.addEventListener("load", () => {
    if (!sessionStorage.getItem('splashed') && document.querySelector("body").classList.contains("home")) {
        setTimeout(() => {
            noscroll()
            splashes.forEach((splash) => {
                splash.classList.add("splash-is-on")
            })
            sessionStorage.setItem('splashed', true);
        }, 300)

    } else {
        document.body.classList.add("splashed")
    }
})

function noscroll() {
    document.addEventListener('touchmove', disableScroll, {
        passive: false
    });
    document.addEventListener('mousewheel', disableScroll, {
        passive: false
    });
    setTimeout(() => {
        document.removeEventListener('touchmove', disableScroll, {
            passive: false
        });
        document.removeEventListener('mousewheel', disableScroll, {
            passive: false
        });
        document.body.classList.add("splashed")
        splashes.forEach((splash) => {
            splash.classList.add("splashed")
        })
    }, 2400);
}

function disableScroll(event) {
    event.preventDefault();
}

// import GUI from 'lil-gui';
// const gui = new GUI();

// const splashfunctions = {}

// splashfunctions.toggleSplash = () => {
//     splashes.forEach((splash) => {
//         splash.classList.toggle("splash-is-on")
//     })
// }
// gui.add(splashfunctions, 'toggleSplash');
